// VaPTODO - v budoucnu vyzkouset, idealne nejakym zatezovym testem, ktera z metod je lepsi, zda
//         - component: ContentCreate nebo component: () => import("../Pages/CorBase/Role/RoleCreate.vue")
//         - idealne pro uzivatele, ktery nema aktivni skoro zadnou funkcionalitu nacist vse dynamicky a staticky
//         - a overit, zda vytizeni pameti, prohlizece, rychlost startu aplikace se nejak projevi

// VaPTODO - spolu s tim prejmenovat zakladni komponenty na List a Detail misto Page, Create atd.

// VaPTODO - vsude kde se v aplikaci pouziva odkaz na nejakou stranku, tak by se mela pouzivat nize definovana konstanta napr.
//         - returnRoute: string = "WorkingUnitsList";
//         - zmenit na
//         - returnRoute: string = PageDefinition.PAGE_WorkingUnitsList;
//         - a k tomu pridat import, ktery asi presunout do core misto import * as PageDefinition from "../Infrastructure/PageDefinition";
//         - JESTE jsem to nasel
//         - logoutCurrentUser - const loginPage = '/Login';


//export const PAGE_GroupDetail = "GroupDetail";
export const PAGE_VpnReservedList = "VpnReservedList";
export const PAGE_VpnReservedDetail = "VpnReservedDetail";
export const PAGE_AddRoleList = "AddRoleList";
export const PAGE_ComponentDetail = "ComponentDetail";
export const PAGE_ComponentList = "ComponentList";
export const PAGE_ReceiverList = "ReceiverList";
export const PAGE_ReceiverDetail = "ReceiverDetail";
export const PAGE_ReceiverAdd = "ReceiverAdd";
export const PAGE_ContentDetail = "ContentDetail";
export const PAGE_ContentList = "ContentList";
export const PAGE_EnumDetail = "EnumDetail";
export const PAGE_EnumList = "EnumList";
export const PAGE_GroupDetail = "GroupDetail";
export const PAGE_GroupList = "GroupList";
export const PAGE_TagList = "TagList";
export const PAGE_TagDetail = "TagDetail";
export const PAGE_CertificateDetail = "CertificateDetail";
export const PAGE_HomePage = "HomePage";
export const PAGE_Login = "Login";
export const PAGE_RegistrationSelf = "RegistrationSelf";
export const PAGE_HistoryLoginPage = "LoginHistoryList";
export const PAGE_LoginHistoryList = "LoginHistoryList";
export const PAGE_NationalHolidayDetail = "NationalHolidayDetail";
export const PAGE_NationalHolidayList = "NationalHolidayList";
export const PAGE_PasswordChange = "PasswordChange";
export const PAGE_PersonDetail = "PersonDetail";
export const PAGE_PersonList = "PersonList";

export const PAGE_RoleDetail = "RoleDetail";
export const PAGE_RoleList = "RoleList";
//export const PAGE_RolesChange = "RolesChange";
export const PAGE_SettingDetail = "SettingDetail";


export const PAGE_TestDetail = "TestDetail";


export const PAGE_SettingGlobalList = "SettingGlobalList";
export const PAGE_SettingTenantList = "SettingTenantList";
export const PAGE_SettingUserList = "SettingUserList";

//původni pred rozdelenim
//export const PAGE_SettingList = "SettingList";
export const PAGE_TaskDetail = "TaskDetail";
export const PAGE_TaskList = "TaskList";
//export const PAGE_TaskPartDetail = "TaskPartDetail"; // KDE SE TOHLE POUZIVA
export const PAGE_TenantDetail = "TenantDetail";
export const PAGE_TenantList = "TenantList";
export const PAGE_UserDetail = "UserDetail";
export const PAGE_UserList = "UserList";
export const PAGE_ChangeLogDetail = "ChangeLogDetail";
export const PAGE_ChangeLogList = "ChangeLogList";
export const PAGE_TrainingList = "TrainingList";


export const PAGE_StatisticsDetail = "StatisticsDetail";

export const PAGE_GlobalSearchList = "GlobalSearchList";

export const PAGE_NotificationViewList = "NotificationViewList";
export const PAGE_NotificationViewDetail = "NotificationViewDetail";

export const PAGE_NotificationSendList = "NotificationSendList";
export const PAGE_NotificationSendDetail = "NotificationSendDetail";
export const PAGE_NotificationSettingDetail = "NotificationSettingDetail";
export const PAGE_NotificationPortalDetail = "NotificationPortalDetail";

export const PAGE_NotificationTemplateList = "NotificationTemplateList";
export const PAGE_NotificationTemplateDetail = "NotificationTemplateDetail";
export const PAGE_GeneralTermList = "GeneralTermList";
export const PAGE_GeneralTermDetail = "GeneralTermDetail";

export const PAGE_SellerDetail = "SellerDetail";
export const PAGE_SellerList = "SellerList";

export const PAGE_TenantpaidDetail = "TenantpaidDetail";

export const PAGE_DiscountDetail = "DiscountDetail";
export const PAGE_TariffDetail = "TariffDetail";
export const PAGE_TariffList = "TariffList";

export const PAGE_PricelistTemplateDetail = "PricelistTemplateDetail";
export const PAGE_PricelistTemplateList = "PricelistTemplateList";

export const PAGE_PricelistDetail = "PricelistDetail";
export const PAGE_PricelistList = "PricelistList";

export const CopyrightYear: number = new Date().getUTCFullYear();

//import COMPONENT_AddRoleList from '../Pages/CorBase/User/AddRoleList.vue';
import COMPONENT_GlobalSearchList from '../Pages/CorBase/GlobalSearch/GlobalSearchList.vue';
import COMPONENT_ChangeLogDetail from '../Pages/CorBase/ChangeLog/ChangeLogDetail.vue';
import COMPONENT_ChangeLogList from '../Pages/CorBase/ChangeLog/ChangeLogList.vue';
import COMPONENT_ComponentDetail from '../Pages/CorBase/Component/ComponentDetail.vue';
import COMPONENT_ComponentList from '../Pages/CorBase/Component/ComponentList.vue';
import COMPONENT_ContentDetail from '../Pages/ContBase/Content/ContentDetail.vue';
import COMPONENT_ContentList from '../Pages/ContBase/Content/ContentList.vue';
import COMPONENT_EnumDetail from '../Pages/CorBase/Enums/EnumDetail.vue';
import COMPONENT_EnumList from '../Pages/CorBase/Enums/EnumList.vue';
import COMPONENT_GroupDetail from '../Pages/CorBase/Group/GroupDetail.vue';
import COMPONENT_GroupList from '../Pages/CorBase/Group/GroupList.vue';

import COMPONENT_VpnReservedList from '../Pages/CorBase/VpnReserved/VpnReservedList.vue';
import COMPONENT_VpnReservedDetail from '../Pages/CorBase/VpnReserved/VpnReservedDetail.vue';

import COMPONENT_TagList from '../Pages/CorBase/Tag/TagList.vue';
import COMPONENT_TagDetail from '../Pages/CorBase/Tag/TagDetail.vue';
import COMPONENT_CertificateDetail from '../Pages/CorBase/Certificate/CertificateDetail.vue';
import COMPONENT_HomePage from '../Pages/HelpPageBase/HomePage.vue';
import COMPONENT_Login from '../Pages/CorBase/User/Login.vue';
import COMPONENT_RegistrationSelf from '../Pages/CorBase/User/RegistrationSelf.vue';
import COMPONENT_LoginHistoryList from '../Pages/CorBase/User/LoginHistoryList.vue';

import COMPONENT_TestDetail from '../Pages/CorBase/Test/TestDetail.vue';
import COMPONENT_NationalHolidayDetail from '../Pages/CorBase/NationalHoliday/NationalHolidayDetail.vue';
import COMPONENT_NationalHolidayList from '../Pages/CorBase/NationalHoliday/NationalHolidayList.vue';
import COMPONENT_PasswordChange from '../Pages/CorBase/User/PasswordChange.vue';
import COMPONENT_PersonDetail from '../Pages/CorBase/Person/PersonDetail.vue';
import COMPONENT_PersonList from '../Pages/CorBase/Person/PersonList.vue';
//import COMPONENT_DetailRole from '../Pages/CorBase/User/DetailRole.vue';
import COMPONENT_RoleDetail from '../Pages/CorBase/Role/RoleDetail.vue';
import COMPONENT_RoleList from '../Pages/CorBase/Role/RoleList.vue';
//import COMPONENT_RolesChange from '../Pages/CorBase/Role/RolesChange.vue';
import COMPONENT_SettingsDetail from '../Pages/CorBase/Settings/SettingDetail.vue';
//import COMPONENT_SettingList from '../Pages/CorBase/Settings/SettingList.vue';

import COMPONENT_SettingGlobalList from '../Pages/CorBase/Settings/SettingGlobalList.vue';
import COMPONENT_SettingTenantList from '../Pages/CorBase/Settings/SettingTenantList.vue';
import COMPONENT_SettingUserList from '../Pages/CorBase/Settings/SettingUserList.vue';

import COMPONENT_TaskDetail from '../Pages/ContBase/Task/TaskDetail.vue';
import COMPONENT_TaskList from '../Pages/ContBase/Task/TaskList.vue';
//import COMPONENT_TaskPartDetail from '../Pages/Cont/Task/TaskPartDetail.vue';
import COMPONENT_ReceiverList from '../Pages/ContBase/Receiver/ReceiverList.vue';
import COMPONENT_ReceiverDetail from '../Pages/ContBase/Receiver/ReceiverDetail.vue';
import COMPONENT_TenantDetail from '../Pages/CorBase/Tenant/TenantDetail.vue';
import COMPONENT_TenantList from '../Pages/CorBase/Tenant/TenantList.vue';
import COMPONENT_UserDetail from '../Pages/CorBase/User/UserDetail.vue';
import COMPONENT_UserList from '../Pages/CorBase/User/UserList.vue';
import COMPONENT_TrainingList from '../Pages/CorBase/Training/TrainingList.vue';
import COMPONENT_ReceiverAdd from '../Pages/ContBase/Receiver/ReceiverAdd.vue';

import COMPONENT_NotificationViewList from '../Pages/CorBase/NotificationView/NotificationViewList.vue';
import COMPONENT_NotificationViewDetail from '../Pages/CorBase/NotificationView/NotificationViewDetail.vue';

import COMPONENT_NotificationSendList from '../Pages/CorBase/NotificationSend/NotificationSendList.vue';
import COMPONENT_NotificationSendDetail from '../Pages/CorBase/NotificationSend/NotificationSendDetail.vue';
import COMPONENT_NotificationSettingDetail from '../Pages/CorBase/NotificationSetting/NotificationSettingDetail.vue';

import COMPONENT_NotificationPortalDetail from '../Pages/CorBase/NotificationPortal/NotificationPortalDetail.vue';

import COMPONENT_NotificationTemplateList from '../Pages/CorBase/NotificationTemplate/NotificationTemplateList.vue';
import COMPONENT_NotificationTemplateDetail from '../Pages/CorBase/NotificationTemplate/NotificationTemplateDetail.vue';
import COMPONENT_GeneralTermList from '../Pages/CorBase/GeneralTerm/GeneralTermList.vue';
import COMPONENT_GeneralTermDetail from '../Pages/CorBase/GeneralTerm/GeneralTermDetail.vue';

import COMPONENT_SellerList from '../Pages/CorBase/Seller/SellerList.vue';
import COMPONENT_SellerDetail from '../Pages/CorBase/Seller/SellerDetail.vue';


import COMPONENT_TariffList from '../Pages/AccBase/Tariff/TariffList.vue';
import COMPONENT_TariffDetail from '../Pages/AccBase/Tariff/TariffDetail.vue';

import COMPONENT_DiscountDetail from '../Pages/AccBase/Discount/DiscountDetail.vue';

import COMPONENT_TenantpaidDetail from '../Pages/AccBase/Tenantpaid/TenantpaidDetail.vue';

import COMPONENT_PricelistTemplateList from '../Pages/AccBase/PricelistTemplate/PricelistTemplateList.vue';
import COMPONENT_PricelistTemplateDetail from '../Pages/AccBase/PricelistTemplate/PricelistTemplateDetail.vue';

import COMPONENT_PricelistList from '../Pages/AccBase/Pricelist/PricelistList.vue';
import COMPONENT_PricelistDetail from '../Pages/AccBase/Pricelist/PricelistDetail.vue';

import COMPONENT_StatisticsDetail from '../Pages/CorBase/Statistics/StatisticsDetail.vue';

export abstract class PageDefinition {

	public static getPageRoutes() {
		return [
			{
				path: "/",
				redirect: '/' + PAGE_HomePage
			},

			PageDefinition.getRouteItemComponent(PAGE_GlobalSearchList, COMPONENT_GlobalSearchList),

			PageDefinition.getRouteItemComponent(PAGE_VpnReservedList, COMPONENT_VpnReservedList),
			PageDefinition.getRouteItemComponent(PAGE_VpnReservedDetail, COMPONENT_VpnReservedDetail),

			PageDefinition.getRouteItemComponent(PAGE_CertificateDetail, COMPONENT_CertificateDetail),
			PageDefinition.getRouteItemComponent(PAGE_ChangeLogDetail, COMPONENT_ChangeLogDetail),
			PageDefinition.getRouteItemComponent(PAGE_ChangeLogList, COMPONENT_ChangeLogList),
			PageDefinition.getRouteItemComponent(PAGE_EnumDetail, COMPONENT_EnumDetail),
			PageDefinition.getRouteItemComponent(PAGE_EnumList, COMPONENT_EnumList),
			PageDefinition.getRouteItemComponent(PAGE_GroupDetail, COMPONENT_GroupDetail),
			PageDefinition.getRouteItemComponent(PAGE_GroupList, COMPONENT_GroupList),
			PageDefinition.getRouteItemComponent(PAGE_TagList, COMPONENT_TagList),
			PageDefinition.getRouteItemComponent(PAGE_TagDetail, COMPONENT_TagDetail),
			PageDefinition.getRouteItemComponent(PAGE_HomePage, COMPONENT_HomePage),
			PageDefinition.getRouteItemComponent(PAGE_Login, COMPONENT_Login),
			PageDefinition.getRouteItemComponent(PAGE_RegistrationSelf, COMPONENT_RegistrationSelf),
			PageDefinition.getRouteItemComponent(PAGE_LoginHistoryList, COMPONENT_LoginHistoryList),
			PageDefinition.getRouteItemComponent(PAGE_PasswordChange, COMPONENT_PasswordChange),
			PageDefinition.getRouteItemComponent(PAGE_PersonDetail, COMPONENT_PersonDetail),
			PageDefinition.getRouteItemComponent(PAGE_PersonList, COMPONENT_PersonList),
			PageDefinition.getRouteItemComponent(PAGE_RoleDetail, COMPONENT_RoleDetail),
			PageDefinition.getRouteItemComponent(PAGE_RoleList, COMPONENT_RoleList),
			//PageDefinition.getRouteItemComponent(PAGE_RolesChange, COMPONENT_RolesChange),
			PageDefinition.getRouteItemComponent(PAGE_SettingDetail, COMPONENT_SettingsDetail),

			PageDefinition.getRouteItemComponent(PAGE_SettingGlobalList, COMPONENT_SettingGlobalList),
			PageDefinition.getRouteItemComponent(PAGE_SettingTenantList, COMPONENT_SettingTenantList),
			PageDefinition.getRouteItemComponent(PAGE_SettingUserList, COMPONENT_SettingUserList),

			//PageDefinition.getRouteItemComponent(PAGE_SettingList, COMPONENT_SettingList),
			PageDefinition.getRouteItemComponent(PAGE_TenantDetail, COMPONENT_TenantDetail),
			PageDefinition.getRouteItemComponent(PAGE_TenantList, COMPONENT_TenantList),
			PageDefinition.getRouteItemComponent(PAGE_TrainingList, COMPONENT_TrainingList),
			PageDefinition.getRouteItemComponent(PAGE_UserDetail, COMPONENT_UserDetail),
			PageDefinition.getRouteItemComponent(PAGE_UserList, COMPONENT_UserList),
			PageDefinition.getRouteItemComponent(PAGE_ComponentDetail, COMPONENT_ComponentDetail),
			PageDefinition.getRouteItemComponent(PAGE_ComponentList, COMPONENT_ComponentList),
			PageDefinition.getRouteItemComponent(PAGE_TestDetail, COMPONENT_TestDetail),
			PageDefinition.getRouteItemComponent(PAGE_NationalHolidayDetail, COMPONENT_NationalHolidayDetail),
			PageDefinition.getRouteItemComponent(PAGE_NationalHolidayList, COMPONENT_NationalHolidayList),
			//	PageDefinition.getRouteItemComponent(PAGE_ContentDetail, () => import('../Pages/Cont/Content/ContentDetail.vue')),
			PageDefinition.getRouteItemComponent(PAGE_ContentDetail, COMPONENT_ContentDetail),
			PageDefinition.getRouteItemComponent(PAGE_ContentList, COMPONENT_ContentList),
			PageDefinition.getRouteItemComponent(PAGE_ReceiverList, COMPONENT_ReceiverList),
			PageDefinition.getRouteItemComponent(PAGE_ReceiverDetail, COMPONENT_ReceiverDetail),
			PageDefinition.getRouteItemComponent(PAGE_TaskList, COMPONENT_TaskList),
			PageDefinition.getRouteItemComponent(PAGE_TaskDetail, COMPONENT_TaskDetail),
			PageDefinition.getRouteItemComponent(PAGE_ReceiverAdd, COMPONENT_ReceiverAdd),

			PageDefinition.getRouteItemComponent(PAGE_NotificationViewList, COMPONENT_NotificationViewList),
			PageDefinition.getRouteItemComponent(PAGE_NotificationViewDetail, COMPONENT_NotificationViewDetail),

			PageDefinition.getRouteItemComponent(PAGE_NotificationSendList, COMPONENT_NotificationSendList),
			PageDefinition.getRouteItemComponent(PAGE_NotificationSendDetail, COMPONENT_NotificationSendDetail),
			PageDefinition.getRouteItemComponent(PAGE_NotificationSettingDetail, COMPONENT_NotificationSettingDetail),
			PageDefinition.getRouteItemComponent(PAGE_NotificationPortalDetail, COMPONENT_NotificationPortalDetail),

			PageDefinition.getRouteItemComponent(PAGE_NotificationTemplateList, COMPONENT_NotificationTemplateList),
			PageDefinition.getRouteItemComponent(PAGE_NotificationTemplateDetail, COMPONENT_NotificationTemplateDetail),

			PageDefinition.getRouteItemComponent(PAGE_GeneralTermList, COMPONENT_GeneralTermList),
			PageDefinition.getRouteItemComponent(PAGE_GeneralTermDetail, COMPONENT_GeneralTermDetail),

			PageDefinition.getRouteItemComponent(PAGE_SellerList, COMPONENT_SellerList),
			PageDefinition.getRouteItemComponent(PAGE_SellerDetail, COMPONENT_SellerDetail),

			PageDefinition.getRouteItemComponent(PAGE_TariffList, COMPONENT_TariffList),
			PageDefinition.getRouteItemComponent(PAGE_TariffDetail, COMPONENT_TariffDetail),

			PageDefinition.getRouteItemComponent(PAGE_DiscountDetail, COMPONENT_DiscountDetail),

			PageDefinition.getRouteItemComponent(PAGE_TenantpaidDetail, COMPONENT_TenantpaidDetail),

			PageDefinition.getRouteItemComponent(PAGE_PricelistTemplateList, COMPONENT_PricelistTemplateList),
			PageDefinition.getRouteItemComponent(PAGE_PricelistTemplateDetail, COMPONENT_PricelistTemplateDetail),

			PageDefinition.getRouteItemComponent(PAGE_PricelistList, COMPONENT_PricelistList),
			PageDefinition.getRouteItemComponent(PAGE_PricelistDetail, COMPONENT_PricelistDetail),

			PageDefinition.getRouteItemComponent(PAGE_StatisticsDetail, COMPONENT_StatisticsDetail),

			// Jako posledni musime byt not found page
			{
				path: "*",
				name: "NotFoundPage",
				component: () =>
					import("../Pages/HelpPageBase/NotFoundPage.vue")
			}
		]
	}


	//VaP TODO - toto pak sjednotit s topmenu a metoudou setPagesToSubMenuItem, kde je stejny cast
	//         - idealne udelat obecnou definici stranek, at se daji nadefinovat na jednom miste a nidke jinde se jiz nepouzivaji
	//         - a pak upravit tyto metody, at vyuzivaji tu deifnici a dokazou podle ni vracet potrebne udaje a vytvorit i mnozinu pro menu, anizh bych musel znat dane kody
	public static getMainPageByIdentifier(identifier: string): string {
		switch (identifier) {
			case 'COR_Certificate':
				return PAGE_CertificateDetail;
			case 'COR_User':
				return PAGE_UserList;
			case 'COR_Role':
				return PAGE_RoleList;
			case 'COR_Group':
				return PAGE_GroupList;
			case 'COR_Tag':
				return PAGE_TagList;
			case 'COR_EnuType':
				return PAGE_EnumList;
			//case 'COR_Setting':
			//	return PAGE_SettingList;
			//nastavim kdyz jako home Page leda global nastaveni (ale o tuhle home page asi nikdo nestoji)
			case 'COR_Setting':
				return PAGE_SettingGlobalList;
			//case 'COR_Setting':
			//	return PAGE_SettingTenantList;
			//case 'COR_Setting':
			//	return PAGE_SettingUserList;
			case 'COR_NationalHoliday':
				return PAGE_NationalHolidayList;
			case 'COR_LoginHistory':
				return PAGE_HistoryLoginPage;
			case 'COR_Tenant':
				return PAGE_TenantList;
			case 'COR_Component':
				return PAGE_ComponentList;
			case 'COR_ChangeLog':
				return PAGE_ChangeLogList;
			case 'COR_Person':
				return PAGE_PersonList;
			case 'COR_Training': //TOHLE NEFUNGUJE 
				return PAGE_TrainingList;
			case 'CON_Content':
				return PAGE_ContentList;
			case 'CON_Receiver':
				return PAGE_ReceiverList;
			case 'CON_Task':
				return PAGE_TaskList;
			case 'COR_NotificationSend':
				return PAGE_NotificationSendList;
			case 'COR_NotificationTemplate':
				return PAGE_NotificationTemplateList;
			case 'COR_Seller':
				return PAGE_SellerList;
			case 'ACC_Tariff':
				return PAGE_TariffList;
			case 'ACC_Tenantpaid':
				return PAGE_TenantpaidDetail;
			case 'ACC_PricelistTemplate':
				return PAGE_PricelistTemplateList;
			case 'ACC_Pricelist':
				return PAGE_PricelistList;
			default:
				return '';
		}
	}

	private static getRouteItemComponent(identifier: string, component: any): any {
		return {
			path: "/" + identifier,
			name: identifier,
			component: component
		};
	}
}
